import React, { useState } from 'react'
import "./services.css"

const Services = () => {
    const [toggleState, setToggleState] = useState(0);

    const toggleTab = (index) => {
        setToggleState(index);
    };
  return (
    <section className="services section" id="services">
    <h2 className="section__title">My Services</h2>
    <span className="section__subtitle">What I offer</span>

        <div className="services__container container grid">
        <div className="services__content">
            <div>
                <i className="uil uil-web-grid services__icon"></i>
                <h3 className="services__title">Front-End <br /> Development</h3>
            </div>

            <span className="services__button" onClick={() => toggleTab(1) }>View More
                <i className="uil uil-arrow-right services__button-icon"></i>
            </span>

                <div className={toggleState === 1 ? "services__modal active-modal" : "services__modal"}>
                    <div className="services__modal-content">
                        <i className="uil uil-times services__modal-close"
                            onClick={() => toggleTab(0)}
                        ></i>

                        <h3 className="services__modal-title">Front-End Developer</h3>
                        <p className="services__modal-description">Create engaging and intuitive user interfaces 
                            with React, HTML, CSS, and JavaScript.
                        Implement responsive design principles to ensure your 
                        application looks great on all devices.</p>


                            <ul className="services__modal-services grid">
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle
                                     services__modal-icon"></i>
                                     <p className="services__modal-info">I develop the user interface</p>
                                </li>
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle
                                     services__modal-icon"></i>
                                     <p className="services__modal-info">Web page Developnment</p>
                                </li>
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle
                                     services__modal-icon"></i>
                                     <p className="services__modal-info">I create ux element interactions</p>
                                </li>
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle
                                     services__modal-icon"></i>
                                     <p className="services__modal-info">I positioned your company brnad</p>
                                </li>
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle
                                     services__modal-icon"></i>
                                     <p className="services__modal-info">Design and Mockups of Products for companies  </p>
                                </li>
                            </ul>
                    </div>
                </div>

        </div>

        <div className="services__content">
            <div>
                <i className="uil uil-arrow services__icon"></i>
                <h3 className="services__title">Back-End <br /> Development</h3>
            </div>

            <span className="services__button" onClick={() => toggleTab(2) }>View More
                <i className="uil uil-arrow-right services__button-icon"></i>
            </span>

                <div className={toggleState === 2 ? "services__modal active-modal" : 
                    "services__modal"}>
                    <div className="services__modal-content">
                        <i  onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                        <h3 className="services__modal-title">Back-End Development</h3>
                        <p className="services__modal-description">Develop scalable server-side applications
                             with Node.js and Express.js.
                        Integrate APIs, manage databases with MongoDB,
                         and ensure secure, efficient data handling.</p>


                            <ul className="services__modal-services grid">
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle
                                     services__modal-icon"></i>
                                     <p className="services__modal-info">I develop the server side</p>
                                </li>
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle
                                     services__modal-icon"></i>
                                     <p className="services__modal-info">Web page Developnment</p>
                                </li>
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle
                                     services__modal-icon"></i>
                                     <p className="services__modal-info">I create ux element interactions</p>
                                </li>
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle
                                     services__modal-icon"></i>
                                     <p className="services__modal-info">I positioned your company brand</p>
                                </li>
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle
                                     services__modal-icon"></i>
                                     <p className="services__modal-info">Design and Mockups of Products for companies  </p>
                                </li>
                            </ul>
                    </div>
                </div>

        </div>

        <div className="services__content">
            <div>
                <i className="uil uil-edit services__icon"></i>
                <h3 className="services__title">Custom Web <br /> Application Development</h3>
            </div>

            <span onClick={() => toggleTab(3)} className="services__button">View More
                <i className="uil uil-arrow-right services__button-icon"></i>
            </span>

                <div className={toggleState === 3 ? "services__modal active-modal" : 
                    "services__modal"}>
                    <div className="services__modal-content">
                        <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                        <h3 className="services__modal-title">Custom Web Application Development</h3>
                        <p className="services__modal-description">Build dynamic, responsive web applications tailored to your 
                            business needs using the MERN stack (MongoDB, Express.js, React, Node.js).</p>


                            <ul className="services__modal-services grid">
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle
                                     services__modal-icon"></i>
                                     <p className="services__modal-info">I develop th user interface</p>
                                </li>
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle
                                     services__modal-icon"></i>
                                     <p className="services__modal-info">Web page Developnment</p>
                                </li>
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle
                                     services__modal-icon"></i>
                                     <p className="services__modal-info">I create ux element interactions</p>
                                </li>
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle
                                     services__modal-icon"></i>
                                     <p className="services__modal-info">I positioned your company brnad</p>
                                </li>
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle
                                     services__modal-icon"></i>
                                     <p className="services__modal-info">Design and Mockups pf Products for companies  </p>
                                </li>
                            </ul>
                    </div>
                </div>

        </div>
    </div>


   


    </section>
  )
}

export default Services